/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterOrigin_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterOrigin_itemSearch";
};
export type SbSharedRefineMenuFilterOrigin_itemSearch$data = SbSharedRefineMenuFilterOrigin_itemSearch;
export type SbSharedRefineMenuFilterOrigin_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterOrigin_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterOrigin_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterOrigin_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'df1a710fcc76821d0e1411806d6d7fc1';
export default node;
